import { useHasRole } from "./permissions";


export const RenderForRoles = ({ roles, children }) => {
  const authorised = useHasRole(roles);
  return authorised ? children : null;
};